// Default settings
settings = {
  formSelector: 'form[action^="/cart/add"]',
  cartContainer: '.enj-minicart-ajax',
  addToCartSelector: '.enj-add-to-cart-btn',
  cartCountSelector: '.enj-cartcount',
  cartCostSelector: '.enj-cartcost',
  moneyFormat: Shopify.money_format,
};

// Select DOM elements
$formContainer = $(settings.formSelector);
$cartContainer = $(settings.cartContainer);
$addToCart = $formContainer.find(settings.addToCartSelector);
$cartCountSelector = $(settings.cartCountSelector);
$cartCostSelector = $(settings.cartCostSelector);

// General Selectors
$body = $('body');

function init() {
  // Track cart activity status
  isUpdating = false;
  qtySelectors();

  // Take over the add to cart form submit action if ajax enabled
  if ($addToCart.length) {
    formOverride();
  }

  adjustCart();
}

function loadCart() {
  ShopifyAPI.getCart(cartUpdateCallback);
}

function updateCountPrice(cart) {
  if ($cartCountSelector) {
    $cartCountSelector.html(cart.item_count).removeClass('hidden-count');
  }
  if ($cartCostSelector) {
    $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
  }
}

function formOverride() {
  $formContainer.on('submit', function (evt) {
    evt.preventDefault();
    cartSubmit(evt);
  });
}

function cartSubmit(evt) {
  var $addToCart_btn = $(this).find(settings.addToCartSelector);
  // Add class to be styled if desired
  $addToCart_btn.removeClass('is-added').addClass('is-adding');
  $addToCart_btn
    .find('i')
    .replaceWith(
      '<i class="enj-loader-add-to-cart"><svg xml:space="preserve" style="enable-background:new 0 0 50 50;margin-top: -1px;" viewBox="0 0 24 30" height="20px" width="21px" y="0px" x="0px" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg" id="Layer_1" version="1.1"><rect opacity="0.2" fill="#fff" height="8" width="3" y="10" x="0"><animate repeatCount="indefinite" dur="0.6s" begin="0s" values="0.2; 1; .2" attributeType="XML" attributeName="opacity"/><animate repeatCount="indefinite" dur="0.6s" begin="0s" values="10; 20; 10" attributeType="XML" attributeName="height"/><animate repeatCount="indefinite" dur="0.6s" begin="0s" values="10; 5; 10" attributeType="XML" attributeName="y"/></rect><rect opacity="0.2" fill="#fff" height="8" width="3" y="10" x="8">      <animate repeatCount="indefinite" dur="0.6s" begin="0.15s" values="0.2; 1; .2" attributeType="XML" attributeName="opacity"/><animate repeatCount="indefinite" dur="0.6s" begin="0.15s" values="10; 20; 10" attributeType="XML" attributeName="height"/><animate repeatCount="indefinite" dur="0.6s" begin="0.15s" values="10; 5; 10" attributeType="XML" attributeName="y"/></rect><rect opacity="0.2" fill="#fff" height="8" width="3" y="10" x="16"><animate repeatCount="indefinite" dur="0.6s" begin="0.3s" values="0.2; 1; .2" attributeType="XML" attributeName="opacity"/><animate repeatCount="indefinite" dur="0.6s" begin="0.3s" values="10; 20; 10" attributeType="XML" attributeName="height"/><animate repeatCount="indefinite" dur="0.6s" begin="0.3s" values="10; 5; 10" attributeType="XML" attributeName="y"/></rect></svg></i>',
    );

  // Remove any previous quantity errors
  $('.qty-error').remove();

  ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
}

function itemAddedCallback(product, form) {
  var $addToCart_btn = $(form).find(settings.addToCartSelector);
  $addToCart_btn.removeClass('is-adding').addClass('is-added');
  $addToCart_btn.find('.enj-loader-add-to-cart').html('<i class="flaticon-tick"></i>');

  $('.product-popup').find('.product-name').html(product.title);
  $('.product-popup').find('.product-image img').attr('src', product.image);

  showPopup('.product-popup');
  $('.engo-popup').show();

  ShopifyAPI.getCart(cartUpdateCallback);
}

function itemErrorCallback(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  $addToCart.removeClass('is-adding is-added');
  $addToCart.find('.enj-loader-add-to-cart').remove();

  if (!!data.message) {
    if (data.status == 422) {
      $formContainer.after('<div class="errors qty-error">' + data.description + '</div>');
    }
  }
}

function cartUpdateCallback(cart) {
  // Update quantity and price
  updateCountPrice(cart);
  buildCart(cart);
}

function buildCart(cart) {
  // Start with a fresh cart div
  $cartContainer.empty();

  // Show empty cart
  if (cart.item_count === 0) {
    $cartContainer.append('<p>' + 'Your cart is currently empty.' + '</p>');
    cartCallback(cart);
    return;
  }

  // Handlebars.js cart layout
  var items = [],
    item = {},
    data = {},
    source = $('#CartTemplate').html(),
    template = Handlebars.compile(source);

  // Add each item to our handlebars.js data
  $.each(cart.items, function (index, cartItem) {
    /* Hack to get product image thumbnail
     *   - If image is not null
     *     - Remove file extension, add _small, and re-add extension
     *     - Create server relative link
     *   - A hard-coded url of no-image
     */
    if (cartItem.image != null) {
      var prodImg = cartItem.image.replace(/(\.[^.]*)$/, '_small$1').replace('http:', '');
    } else {
      var prodImg = '//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif';
    }

    // Create item's data object and add to 'items' array
    item = {
      id: cartItem.variant_id,
      line: index + 1, // Shopify uses a 1+ index in the API
      url: cartItem.url,
      img: prodImg,
      name: cartItem.product_title,
      variation: cartItem.variant_title,
      properties: cartItem.properties,
      itemAdd: cartItem.quantity + 1,
      itemMinus: cartItem.quantity - 1,
      itemQty: cartItem.quantity,
      price: Shopify.formatMoney(cartItem.price, settings.moneyFormat),
      vendor: cartItem.vendor,
    };

    items.push(item);
  });

  // Gather all cart data and add to DOM
  data = {
    items: items,
    vehicle: window.Convermax.getVehicle(), // get current selected vehicle
    note: cart.note,
    totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat),
  };

  $cartContainer.append(template(data));

  cartCallback(cart);
}

function cartCallback(cart) {
  $body.removeClass('drawer--is-loading');
  $body.trigger('ajaxCart.afterCartLoad', cart);
}

function adjustCart() {
  // Delegate all events because elements reload with the cart

  // Add or remove from the quantity
  $body.on('click', '.ajaxcart__qty-adjust', function () {
    var $el = $(this),
      line = $el.data('line'),
      $qtySelector = $el.siblings('.ajaxcart__qty-num'),
      qty = parseInt($qtySelector.val().replace(/\D/g, ''));

    var qty = validateQty(qty);

    // Add or subtract from the current quantity
    if ($el.hasClass('ajaxcart__qty--plus')) {
      qty += 1;
    } else {
      qty -= 1;
      if (qty <= 0) qty = 0;
    }
    console.log('Qty: ' + qty);
    // If it has a data-line, update the cart.
    // Otherwise, just update the input's number
    if (line) {
      updateQuantity(line, qty);
    } else {
      $qtySelector.val(qty);
    }
  });

  // Prevent cart from being submitted while quantities are changing
  $body.on('submit', 'form.ajaxcart', function (evt) {
    if (isUpdating) {
      evt.preventDefault();
    }
  });

  // Highlight the text when focused
  $body.on('focus', '.ajaxcart__qty-adjust', function () {
    var $el = $(this);
    setTimeout(function () {
      $el.select();
    }, 50);
  });

  function updateQuantity(line, qty) {
    isUpdating = true;

    // Add activity classes when changing cart quantities
    var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

    if (qty === 0) {
      $row.parent().addClass('is-removed');
    }

    // Slight delay to make sure removed animation is done
    setTimeout(function () {
      ShopifyAPI.changeItem(line, qty, adjustCartCallback);
    }, 250);
  }

  // Save note anytime it's changed
  $body.on('change', 'textarea[name="note"]', function () {
    var newNote = $(this).val();

    // Update the cart note in case they don't click update/checkout
    ShopifyAPI.updateCartNote(newNote, function (cart) {});
  });
}

function adjustCartCallback(cart) {
  isUpdating = false;

  // Update quantity and price
  updateCountPrice(cart);

  // Reprint cart on short timeout so you don't see the content being removed
  setTimeout(function () {
    ShopifyAPI.getCart(buildCart);
  }, 150);
}

function createQtySelectors() {
  // If there is a normal quantity number field in the ajax cart, replace it with our version
  if ($('input[type="number"]', $cartContainer).length) {
    $('input[type="number"]', $cartContainer).each(function () {
      var $el = $(this),
        currentQty = $el.val();

      var itemAdd = currentQty + 1,
        itemMinus = currentQty - 1,
        itemQty = currentQty;

      var source = $('#AjaxQty').html(),
        template = Handlebars.compile(source),
        data = {
          id: $el.data('id'),
          itemQty: itemQty,
          itemAdd: itemAdd,
          itemMinus: itemMinus,
        };

      // Append new quantity selector then remove original
      $el.after(template(data)).remove();
    });
  }
}

function qtySelectors() {
  // Change number inputs to JS ones, similar to ajax cart but without API integration.
  // Make sure to add the existing name and id to the new input element
  var numInputs = $('#product-qty-input');

  if (numInputs.length) {
    numInputs.each(function () {
      var $el = $(this),
        currentQty = $el.val(),
        inputName = $el.attr('name'),
        inputId = $el.attr('id');

      var itemAdd = currentQty + 1,
        itemMinus = currentQty - 1,
        itemQty = currentQty;

      var source = $('#JsQty').html(),
        template = Handlebars.compile(source),
        data = {
          id: $el.data('id'),
          itemQty: itemQty,
          itemAdd: itemAdd,
          itemMinus: itemMinus,
          inputName: inputName,
          inputId: inputId,
        };

      // Append new quantity selector then remove original
      $el.after(template(data)).remove();
    });

    // Setup listeners to add/subtract from the input
    $('.js-qty__adjust').on('click', function () {
      var $el = $(this),
        id = $el.data('id'),
        $qtySelector = $el.siblings('.js-qty__num'),
        qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      qty = validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass('js-qty__adjust--plus')) {
        qty += 1;
        console.log(qty);
        updatePricingQty(qty);
      } else {
        qty -= 1;
        if (qty <= 1) qty = 1;
        updatePricingQty(qty);
      }

      // Update the input's number
      $qtySelector.val(qty);
    });
  }
}

function updatePricingQty(qty) {
Currency.format = 'money_with_currency_format';
var cookieCurrency = Currency.cookie.read();

var $variant_sellector  = $("#productSelect option:selected");

    var regex = /([0-9]+[.|,][0-9]+[.|,][0-9]+)/g;
    var unitPriceTextMatch = $($variant_sellector).text().match(regex);

    if (!unitPriceTextMatch) {
      regex = /([0-9]+[.|,][0-9]+)/g;
      unitPriceTextMatch = $($variant_sellector).text().match(regex);
    }

    if (unitPriceTextMatch) {
      var quantity,
          unitPriceText = unitPriceTextMatch[0],
          unitPrice = unitPriceText.replace(/[.|,]/g, '');
      if(!qty) {
        quantity = parseInt($('#Quantity').val(), 10);
      } else {
        quantity = qty;
      }
      
      
      var totalPrice = unitPrice * quantity;
      //totalPrice = Currency.convert(totalPrice,shopCurrency, cookieCurrency);
      var totalPriceText = Shopify.formatMoney(totalPrice, window.money_format);

      regex = /([0-9]+[.|,][0-9]+[.|,][0-9]+)/g;
      if (!totalPriceText.match(regex)) {
        regex = /([0-9]+[.|,][0-9]+)/g;
      }        
      totalPriceText = totalPriceText.match(regex)[0];
      
      var currentPriceText = $(".engoj_price_main");
      regex = /([0-9]+[.|,][0-9]+[.|,][0-9]+)/g;
      if (!currentPriceText.text().match(regex)) {
        regex = /([0-9]+[.|,][0-9]+)/g;
      }
      currentPriceText = currentPriceText.text().match(regex)[0]
      

      var regInput = new RegExp(currentPriceText, "g");
      

      var totalPriceHtml = $(".engoj_price_main").html().replace(regInput, totalPriceText);
      
      $(".engoj_price_main").html(totalPriceHtml);
      
  }
}

function validateQty(qty) {
  if (parseFloat(qty) == parseInt(qty) && !isNaN(qty)) {
    // We have a valid number!
  } else {
    // Not a number. Default to 1.
    qty = 1;
  }
  return qty;
}

window.ajaxCartLoad = loadCart();

$(document).ready(function () {
  init();
  loadCart();
});

$(document).on('submit', 'form[action*="/cart/add"]', function (e) {
  e.preventDefault();
  cartSubmit(e);
});
